import { CbsConsentComponent } from '../component/cbs-consent/cbs-consent.component';
import { PayNowServiceComponent } from '../component/pay-now-service/pay-now-service.component';
import { ConfirmRemoveFileComponent } from '../component/confirm-remove-file/confirm-remove-file.component';
import { MarketingConsentComponent } from '../component/marketing-consent/marketing-consent.component';
import { VerificationFailedComponent } from '../component/verification-failed/verification-failed.component';
import { SessionExpiredComponent } from '../component/session-expired/session-expired.component';
import { CommonErrorComponent } from '../component/common-error/common-error.component';
import { UnableToProceedComponent } from '../component/unable-to-proceed/unable-to-proceed.component';

export const DIALOG_CONTENT = {
  cbsConsent: CbsConsentComponent,
  cimbPayNowService: PayNowServiceComponent,
  commonError: CommonErrorComponent,
  confirmBeforeChange: ConfirmRemoveFileComponent,
  marketingConsent: MarketingConsentComponent,
  sessionExpired: SessionExpiredComponent,
  verificationFailed: VerificationFailedComponent,
  unableToProceed: UnableToProceedComponent,
} as const;
